// Mirrors angelai-header-widget's themes.json `angelai.vars.navbar-active-bg`
// (https://{CDN}/angelai-header-widget/themes.json), which is also the fallback
// baked into renderer.css: `.navbar.active { background: var(--header-navbar-active-bg, #0b1237); }`.
// Kept here so the footer's bg-color override can match it without hardcoding
// the hex in two components.
export const HEADER_NAVBAR_ACTIVE_BG = '#0b1237';
